/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import styled from '@emotion/styled'
import { CSSProperties } from 'react'

import { THEMES } from '@/constants'
import useTheme from '@/hooks/useTheme'
import { ReactComponent as BlackLogo } from '@/vendor/logo-black.svg'
import { ReactComponent as BlackMiniLogo } from '@/vendor/logo-black-mini.svg'
import { ReactComponent as WhiteLogo } from '@/vendor/logo-white.svg'
import { ReactComponent as WhiteMiniLogo } from '@/vendor/logo-white-mini.svg'

const Logo = styled.div`
  width: 80%;
  max-width: 440px;
  height: 64px;
  overflow: hidden;
  svg {
    width: 100%;
    height: 100%;
  }
`

function DaiLogo({
  sx,
  compact = false,
}: {
  sx?: CSSProperties
  compact?: boolean
}) {
  const { theme } = useTheme()
  const darkMode = theme === THEMES.DARK
  return (
    <Logo
      style={
        compact
          ? {
              width: 24,
              maxWidth: 24,
              height: 24,
              ...sx,
            }
          : sx
      }
    >
      {compact ? (
        darkMode ? (
          <WhiteMiniLogo />
        ) : (
          <BlackMiniLogo />
        )
      ) : darkMode ? (
        <WhiteLogo />
      ) : (
        <BlackLogo />
      )}
    </Logo>
  )
}

export default DaiLogo
